import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[twoDigitDecimaNumber]',
    standalone: false
})
export class TwoDigitDecimaNumberDirective {
    // Allow positive decimal numbers with up to two decimal places (no negatives)
    private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
    // Allow key codes for special events. Reflect :
    // Backspace, tab, end, home
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

    constructor(private el: ElementRef) {
    }
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Allow Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        const current: string = this.el.nativeElement.value;
        // Respect the current selection: the typed key replaces the selected range,
        // so validate the actual resulting value (start..end), not just the caret position.
        const start = this.el.nativeElement.selectionStart;
        const end = this.el.nativeElement.selectionEnd;
        const key = event.key == 'Decimal' ? '.' : event.key;
        const next: string = current.slice(0, start) + key + current.slice(end);
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    }
}